import { CityTownVM, DocTypeVM } from "./ISearchService";
import { IndexGroupsVM } from "./ISearchServiceReg";

export class Utility {
  fromDate: string;
  toDate: string;
  lastcorpName: string;
  fName: string;
  citytowns: CityTownVM[];
  doctypes: DocTypeVM[];
  //docCategory: string;
  //doctype: string;
  roleID: number;
  contains: number;
  lastcorpName2: string;
  fName2: string;
  role2ID: number;
  indexId: number;
  streetNumber: string;
  streetAddress: string;
  book: string;
  page: string;
  docnum: string;
  fromAmount: string;
  toAmount: string;
  //set LastCorpName(value: string) {
  //  this._lastcorpName = value;
  //}

  //get LastCorpName(): string {
  //  return this._lastcorpName;

  //}  
}

export class CompoundNameCIF {
  lastcorpName: string;
  fName: string;
}

export class CompoundName2CIF {
  lastcorpName2: string;
  fName2: string;
}

export class CompoundDoubleNameCIF {
  lastcorpName: string;
  fName: string;
  roleID: number;
  lastcorpName2: string;
  fName2: string;
  roleID2: number;
}

export class CityTownCIF {
  citytowns: CityTownVM[];
}

export class RoleCIF {
  roleID: number | undefined;
}
export class Role2CIF {
  role2ID: number | undefined;
}

export class ContainsCIF {
  contains: number | undefined;
}

export class SelectIndexCIF {
  indexId: number | undefined;
}

export class AddressCIF  {
  streetNumber: string;
  streetAddress: string;
}
export class DateRangeCIF {
  fromDate: Date;
  toDate: Date;
}
export class DocTypeCIF  {
  doctypes: DocTypeVM[];
}

export class DocNumCIF {
  docnum: string;
}

export class DocNumcompoundCIF {
  docNumPrimary: string;
  docNumSecondary: string;
}

export class AmountRangeCIF {
  type: string = 'rng';
  fromAmount?: number | undefined;
  toAmount?: number | undefined;
}

export class DocCategoriesCIF {
  mortgages: boolean;
  conveyances: boolean;
}

export class DocCategories2CIF {
  //deeds: boolean;
  //homestead: boolean;
  //foreclosures: boolean;
  //liensAndMortgages: boolean;
  //discharges: boolean;
  //allDocuments: boolean;
  docCategory: string;
}

export class CertNumCIF {
  certnum: string;
}

export class NameCIF {
  name: string;
}

export class PlanRoleCIF {
 planroleID: number | undefined;
}

export class PlanNumCIF {
  plannum: string;
}

export class PlanCertTypeCIF {
  id: number;
  certnum: string;
}
export class UnindexDateRangeCIF {
  dateranges: IndexGroupsVM[];
}

export class RoleTypeCIF {
  roleID: number | undefined;
}

export class UnindexDateRange {
  dateRangeId: number | undefined;
  dateRange: string | undefined;
  IsSelected: boolean;
}

export class CompoundNameIdxCIF {
  lastcorpName: string;
  fName: string;
}
